export default "__VITE_ASSET__Am1BSXNp__"